module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.dc584d06.svg";